// Tiny word-level diff (LCS) for prose redlines. No external dependency.
export type DiffPart = { type: 'equal' | 'add' | 'remove'; text: string };

/** Split keeping whitespace so re-joins are loss-less. */
function tokens(s: string): string[] {
  return s.match(/\s+|\S+/g) ?? [];
}

export function wordDiff(oldText: string, newText: string): DiffPart[] {
  const a = tokens(oldText);
  const b = tokens(newText);
  const n = a.length;
  const m = b.length;
  // LCS length table.
  const dp: number[][] = Array.from({ length: n + 1 }, () => new Array<number>(m + 1).fill(0));
  for (let i = n - 1; i >= 0; i -= 1) {
    for (let j = m - 1; j >= 0; j -= 1) {
      dp[i]![j] = a[i] === b[j] ? dp[i + 1]![j + 1]! + 1 : Math.max(dp[i + 1]![j]!, dp[i]![j + 1]!);
    }
  }
  const out: DiffPart[] = [];
  const push = (type: DiffPart['type'], text: string) => {
    const last = out[out.length - 1];
    if (last && last.type === type) last.text += text;
    else out.push({ type, text });
  };
  let i = 0;
  let j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) { push('equal', a[i]!); i += 1; j += 1; }
    else if (dp[i + 1]![j]! >= dp[i]![j + 1]!) { push('remove', a[i]!); i += 1; }
    else { push('add', b[j]!); j += 1; }
  }
  while (i < n) { push('remove', a[i]!); i += 1; }
  while (j < m) { push('add', b[j]!); j += 1; }
  return out;
}
